/**
 * Scelta del tema: Scuro / Chiaro / Come il telefono (Andrea 2026-10-08).
 * Usato nel Profilo e nel menu a tendina su telefono.
 */

import { impostaTema, type Tema, useTema } from "../../lib/tema";
import { tr } from "../../i18n";

const VOCI: { id: Tema; label: string; icona: string }[] = [
  { id: "scuro", label: tr("Scuro"), icona: "🌙" },
  { id: "chiaro", label: tr("Chiaro"), icona: "☀️" },
  { id: "sistema", label: tr("Automatico"), icona: "📱" },
];

export function SelettoreTema({ compatto = false }: { compatto?: boolean }) {
  const tema = useTema();
  return (
    <div
      role="radiogroup"
      aria-label={tr("Tema")}
      className={`flex gap-1 p-1 rounded-xl bg-primary-deep/70 border border-primary/30 ${
        compatto ? "" : "w-full"
      }`}
    >
      {VOCI.map((v) => (
        <button
          key={v.id}
          type="button"
          role="radio"
          aria-checked={tema === v.id}
          onClick={() => impostaTema(v.id)}
          className={`flex-1 rounded-lg font-bold transition whitespace-nowrap ${
            compatto ? "px-2 py-1 text-[11px]" : "px-2 py-2 text-xs"
          } ${tema === v.id ? "bg-accent text-ink shadow" : "text-fg-muted hover:text-fg"}`}
        >
          <span aria-hidden className="mr-1">
            {v.icona}
          </span>
          {tr(v.label)}
        </button>
      ))}
    </div>
  );
}
